import Icon from '@components/common/assets';
import Text from '@components/common/text';
import { FontStyle } from '@domain/constant/fontStyle';
import { ContentRouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import Link from 'next/link';
import { CSSProperties, FC } from 'react';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface Props {
  style?: CSSProperties;
}
const Dimm: FC<Props> = ({ style }) => {
  return (
    <div className={cx('dimm')} style={style}>
      <div className={cx('content')}>
        <div className={cx('icon')}>
          <Icon name="lockGreen" width={40} height={40} />
        </div>

        <Text fontStyle={FontStyle.B1P_B} styles={{ marginTop: 12 }}>
          제휴 서비스를 신청하면
          <br />
          기출 면접 연습을 할 수 있어요!
        </Text>
        <Link className={cx('button')} href={ContentRouteUrl.MY_PAGE_PREMIUM + '?allianceModal=true'}>
          제휴 리스트 확인하기
        </Link>
      </div>
    </div>
  );
};

export default Dimm;
